import { useState, useEffect, useMemo, lazy, FC } from 'react';

import { useLocation } from 'react-router-dom';

import { useUserAuth } from '~/components/Auth';

import { getRouteBasedBannerData } from './utils';
import { getMaintenanceBanner } from './utils/apiService';

interface BannerData {
  adminRoutes?: Record<string, any>;
  learnerRoutes?: Record<string, any>;
}

interface MaintenanceProps {
  isAdmin: boolean;
}

const LazyBanner = lazy(
  () => import(/* webpackChunkName: "bannerComponent" */ /* webpackPrefetch: true */ './Banner')
);

const Maintenance: FC<MaintenanceProps> = ({ isAdmin }) => {
  const {
    company: { id: cname },
  } = useUserAuth();

  const location = useLocation();

  const [bannerData, setBannerData] = useState<Record<string, any>>({});

  useEffect(() => {
    getMaintenanceBanner({ cname }).then((bannerData: BannerData) => {
      if (isAdmin) {
        setBannerData(bannerData?.adminRoutes || {});
      } else {
        setBannerData(bannerData?.learnerRoutes || {});
      }
    });
  }, [cname, isAdmin]);
  const [route, routeBannerData] = useMemo(
    () => getRouteBasedBannerData(bannerData, location.pathname),
    [location.pathname, bannerData]
  );

  if (!route || !routeBannerData) return null;

  return (
    <LazyBanner
      key={route}
      bannerData={bannerData}
      setBannerData={setBannerData}
      route={route}
      currentBannerData={routeBannerData}
    />
  );
};

export default Maintenance;
